import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import SaveLawListWidget from '../../../widgets/saveLawList/SaveLawListWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getLawLists } from '../../../redux/actions/legal'

export default function SaveLawList() {
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId') // projectId = lawId
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    // let litigationId = location.search.substring(1)
    let litigationId = sessionStorage.getItem('param')?.substring(1)

    console.log('litigationId : ', litigationId)

    handleGetSchema(litigationId)
  }, [])

  const handleGetSchema = async (lawId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getLawLists(lawId)
      // console.log('schema ', _schema)
      setSchema(_schema)
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isLegalManagement>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isLegalManagement>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isLegalManagement>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      <SaveLawListWidget schema={schema} projectId={projectId} />

      <br />
    </SidebarProposal>
  )
}
